
import { defineComponent } from 'vue';
import GameService from '@/services/GameService';
import OnboardingChecklistService from '@/services/OnboardingChecklistService';
import ResponseData from '@/_models/ResponseData';
import GameReleaseService from '@/services/GameReleaseService';
import gameDetails from '@/modules/games/components/tabGamePage/gamesTabGamePageDetailsComponent.vue';
import about from '@/modules/games/components/tabGamePage/gamesTabGamePageAboutComponent.vue';
import gallery from '@/modules/games/components/tabGamePage/gamesTabGamePageGalleryComponent.vue';

import gameToken from '@/modules/games/components/tabGameToken/gamesTabGameTokenComponent.vue';
import gameRelease from '@/modules/games/components/tabGameRelease/gamesTabGameReleaseComponent.vue';
import gamesUpdateSubmitMainnetGameComponent from '@/modules/games/components/gamesUpdateSubmitMainnetGameComponent.vue';

import { Helper } from "@/utils/Helper";
import store from "@/store/index";

export default defineComponent({
  data: function () {
    return {
      step1: true,
      step2: false,

      imageFiles: {
        imageFile: "",
        coverImageFile: "",
      },
      hasChanged: false,
      fileName: "",
      previewImage: "",
      oriPreviewImage: "",
      previewCoverImage: "",
      oriPreviewCoverImage: "",
      gameId: "JSUD8273LDSHDLKSDFOIUR",
      gameName: "Enter Game Name",
      gameTitle: "",
      gameCategory: "",
      gameContent: "",
      status: null,
      viewrow: false,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      invitedGamers: [],
      addedGamers: [],
      addedMainnetGamers: [],
      gameData: null,
      gamerEmail: "",
      isInvitingGamers: false,
      createdTime: "",
      createdDate: "",
      submitDate: "",
      submitTime: "",
      version: '',
      rejectedText: "",
      rejectedVersion: "",
      mainTabSelected: "games",
      gameTabSelected: "details",
      selectedWebglRelease: '',
      webglRelease: [],
      selectedAndroidRelease: '',
      androidRelease: [],
      gallery: [],

      isDisplaySubmitCheckList: false,

      isDisplayRejectModal: false,
      isDisplayUpdateGameModal: false,
      isDisplayInviteGamersModal: false,

      isDisplayUploadCoverPhotoLabel: false,
      isDisplaySaveCoverPhotoOptions: false,
      isDisplaySaveCoverUploading: false,

      isDisplayUploadProfilePhotoLabel: false,
      isDisplaySaveProfilePhotoOptions: false,
      isDisplaySaveProfileUploading: false,

      showLoader: false,
      showProgress: false,
      submitTestNet: false,
      releaseTestNet: false,
      gameLoaded: false,

      currentInviteTab:'testnet',

      rows: [],
      languageList: [],
    };
  },
  name: "viewGamesUpdate",
  components: {
    gameDetails,
    about,
    gallery,
    gameToken,
    gameRelease,
    gamesUpdateSubmitMainnetGameComponent
  },
  methods: {
    getLoaderStatus(value) {
      this.showLoader = value;
      this.generateGameReleases(this.$route.params.gameId.toString());
    },
    showProgressBar(value) {
      this.showProgress = value;
    },
    selectImage() {
      this.$refs.fileInput.click();
    },

    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFiles.imageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        // this.$refs.gameDetails.hasChanged = true;
        this.isDisplaySaveProfilePhotoOptions = true;
      }
    },

    

    selectCoverImage() {
      this.$refs.coverFileInput.click();
    },

    pickCoverFile() {
      let input = this.$refs.coverFileInput;
      let file = input.files;
      this.fileName = file[0].name;
      this.imageFiles.coverImageFile = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewCoverImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
        // this.$refs.gameDetails.hasChanged = true;
        // display Save or Discard options
        this.isDisplaySaveCoverPhotoOptions = true;
      }
    },

    revertCoverImage(){
      this.previewCoverImage = this.oriPreviewCoverImage;
      this.isDisplaySaveCoverPhotoOptions = false;
      this.$refs.coverFileInput.value = null;
    },

    updateCoverImage() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        this.isDisplaySaveCoverPhotoOptions = false;
        this.isDisplaySaveCoverUploading = true;
        let gameId = this.$route.params.gameId.toString();
        let formData = new FormData();
        if (this.imageFiles.coverImageFile !== "") {
          formData.append("HeaderImageStream", this.imageFiles.coverImageFile[0]);
          GameService.updateGameDetails(gameId, this.userData.userId, this.jwtToken, formData)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
              this.$refs.coverFileInput.value = null;
              this.isDisplaySaveCoverUploading = false;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
            });
        }
      }
    },

    revertProfilePhoto(){
      this.previewImage = this.oriPreviewImage;
      this.isDisplaySaveProfilePhotoOptions = false;
      this.$refs.fileInput.value = null;
    },

    updateProfilePhoto() {
      if ( this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        this.isDisplaySaveProfilePhotoOptions = false;
        this.isDisplaySaveProfileUploading = true;
        let gameId = this.$route.params.gameId.toString();
        let formData = new FormData();

         if (this.imageFiles.imageFile !== "") {
          formData.append("LogoStream", this.imageFiles.imageFile[0]);

          GameService.updateGameDetails(gameId, this.userData.userId,this.jwtToken, formData)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
              this.$refs.fileInput.value = null;
              this.isDisplaySaveProfileUploading = false;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
            });
        }
      }
    },

    getGameDetails() {
      this.gameLoaded = true;

      if (this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId.toString();

        GameService.getGame(gameId)
          .then((response: ResponseData) => {
            if (response.status === 200) {
              this.selectedTags = response.data.viewModel.game.tags;
              this.gameId = gameId;
              this.gameTitle = this.gameName = response.data.viewModel.game.title;
              this.gameContent = response.data.viewModel.game.contentRating;
              this.gameCategory = response.data.viewModel.game.category;
              this.gameData = response.data.viewModel;
              this.status = response.data.viewModel.game.status;
              this.submitTime = Helper.formatTime(response.data.viewModel.game.updated);
              this.submitDate = Helper.formatDate(response.data.viewModel.game.updated);
              this.createdTime = Helper.formatTime(response.data.viewModel.game.created);
              this.createdDate = Helper.formatDate(response.data.viewModel.game.created);
              this.version = response.data.viewModel.game.version;
              if(response.data.viewModel.details){
                this.gallery = response.data.viewModel.details.gallery.galleryImages;
              }

              if (response.data.viewModel.details !== null && response.data.viewModel.details.gallery.headerImage !== null) {
                this.previewCoverImage = this.assetUrl + "blob/games/" + gameId + "/gallery/" + response.data.viewModel.details.gallery.headerImage;
                this.oriPreviewCoverImage = this.assetUrl + "blob/games/" + gameId + "/gallery/" + response.data.viewModel.details.gallery.headerImage;
              }

              if (response.data.viewModel.game.logo !== null) {
                this.previewImage = this.assetUrl + "blob/games/" + gameId + "/" + response.data.viewModel.game.logo;
                this.oriPreviewImage = this.assetUrl + "blob/games/" + gameId + "/" + response.data.viewModel.game.logo;
              }

              if (this.status === 1) {
                this.getGameSubmission();
              }
              //if(this.status != 2){
                // fetch game release and sort them between webgl and android
                this.generateGameReleases(gameId);
              //}
              this.gameLoaded = false;
            }
          })
          .catch((error) => {
            console.log(error)
            Helper.endpointErrorHandling(error);
            this.gameLoaded = false;
          });
      }
    },

    generateGameReleases(gameId) {
      GameReleaseService.getReleasesList(gameId, this.userData.userId, this.jwtToken)
          .then((response: ResponseData) => {
            if(response.status == 200){
              this.webglRelease = response.data.filter(game => game.platform == 'WebGL').sort((a, b) => b.version > a.version).slice(0, 5);
              this.androidRelease = response.data.filter(game => game.platform == 'Android').slice(0, 5);
            }
          })
    },

    submitGameForReview() {
      this.showLoader = true;
      this.submitTestNet = true;
      if (this.userData !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;

        let gamePackage = [];

        if (this.selectedWebglRelease !== "") {
          let packageRelease = {
            Platform: "WebGL",
            Version: this.selectedWebglRelease
          }
          gamePackage.push(packageRelease)
        }

        if (this.selectedAndroidRelease !== "") {
          let packageRelease = {
            Platform: "Android",
            Version: this.selectedAndroidRelease
          }
          gamePackage.push(packageRelease)
        }

        GameReleaseService.submitGame(gameId, this.userData.userId, gamePackage)
          .then((response: ResponseData) => {
            // this.getGameDetails(gameId, this.userData.userId, this.jwtToken);
            Helper.toastSuccessHandling(response.data['message']);
            this.showLoader = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
            this.showLoader = false;
          });
      }
    },

    publishGame() {
      this.showLoader = true;
      this.releaseTestNet = true;
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;

        GameReleaseService.publishGame(gameId, this.userData.userId, this.jwtToken, 'testnet')
          .then((response: ResponseData) => {
            this.updateOnboardingChecklist(this.userData.userId, this.jwtToken);
            this.getGameDetails(gameId, this.userData.userId, this.jwtToken);
            Helper.toastSuccessHandling(response.data['message']);
            this.showLoader = false;
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.status = 0;
            }
            Helper.endpointErrorHandling(error);
            this.showLoader = false;
          });
      }
    },

    updateGameTitle() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId.toString();
        let formData = new FormData();

        if (this.gameTitle !== "") {
          formData.append("title", this.gameTitle);
        }

        GameService.updateGameDetails(gameId, this.userData.userId, this.jwtToken, formData)
          .then((response: ResponseData) => {
            Helper.toastSuccessHandling(response.data['message']);
            this.gameName = this.gameTitle;
            this.isDisplayUpdateGameModal = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    addGamer() {
      // console.log(this.gamerEmail)
      let invitedEmails = [];
      let emailsBySpacing = [];
      emailsBySpacing = this.gamerEmail.split(" ");
      if(emailsBySpacing.length > 0 ){
        for(let a = 0; a < emailsBySpacing.length; ++a){
          let emailsByComma = [];
          emailsByComma = emailsBySpacing[a].split(",");
          if(emailsByComma.length > 0){
            for( let b = 0; b < emailsByComma.length; ++b){
              if(emailsByComma[b].trim()){
                // console.log(b)
                // console.log(emailsByComma[b])
                let emailsByNewLine = [];
                emailsByNewLine = emailsByComma[b].split("\n");
                if(emailsByNewLine.length > 0){
                  for( let c = 0; c < emailsByNewLine.length; ++c){
                    // add email to emailList
                    invitedEmails.push(emailsByNewLine[c]);
                  }
                }else{
                  // add email to emailList
                  invitedEmails.push(emailsByComma[b]);
                }
              }
            }
          }
        }
      }
      let uniqueGamerEmails = [...new Set(invitedEmails)];

      const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(uniqueGamerEmails.length > 0){
        for(let d = 0; d < uniqueGamerEmails.length; ++d){
          if (emailRegEx.test(uniqueGamerEmails[d])) {
            // if(!this.invitedGamers.includes(uniqueGamerEmails[d].trim())){
            this.invitedGamers.push(uniqueGamerEmails[d].trim());
            // }
          } else {
            Helper.endpointErrorHandling('', 'Invalid email address has been removed - ' + uniqueGamerEmails[d].trim());
          }
        }
        if(invitedEmails.length > uniqueGamerEmails.length ){
          Helper.endpointErrorHandling('', (invitedEmails.length - uniqueGamerEmails.length) + ' duplicate email' + ((invitedEmails.length - uniqueGamerEmails.length)>1)?'s have':' has' + ' been removed from the list');
        }
      }
      this.gamerEmail = '';
      // if (emailRegEx.test(this.gamerEmail)) {
      //   if(this.invitedGamers.includes(this.gamerEmail.trim())){
      //     Helper.endpointErrorHandling('', 'This email is already added in the Newly Invited Gamers list');
      //   }else{
      //     this.invitedGamers.push(this.gamerEmail.trim());
      //     this.gamerEmail = '';
      //   }
      // } else {
      //   Helper.endpointErrorHandling('', 'Invalid email address!');
      // }
    },

    inviteGamers(network: string) {
      this.isInvitingGamers = true;
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;

        if(network == 'testnet'){
          GameService.inviteGamers(gameId, this.userData.userId, this.jwtToken, this.invitedGamers)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling('Success! Gamer' + ((this.invitedGamers.legnth > 1)?'s':'') + ' invited in ' + this.testnetLabel + '!');
              this.getInvitedGamers();
              this.invitedGamers = [];
              this.isDisplayInviteGamersModal = false;
              this.isInvitingGamers = false;
            })
            .catch((error) => {
              Helper.endpointErrorHandling(error);
            });
        }else{
          GameService.inviteMainnetGamers(gameId, this.userData.userId, this.jwtToken, this.invitedGamers)
          .then((response: ResponseData) => {
            Helper.toastSuccessHandling('Success! Gamer' + ((this.invitedGamers.legnth > 1)?'s':'') + ' invited in ' + this.mainnetLabel + '!');
            this.getInvitedMainnetGamers();
            this.invitedGamers = [];
            this.isDisplayInviteGamersModal = false;
            this.isInvitingGamers = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
        }
      }
    },

    getInvitedGamers() {
      this.isDisplayInviteGamersModal = true;
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;

        GameService.getInvitedGamers(gameId, this.userData.userId, this.jwtToken, 'testnet')
          .then((response: ResponseData) => {
            this.addedGamers = response.data;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
        if(this.status == 4){
          this.getInvitedMainnetGamers();
        }
      }
    },

    getInvitedMainnetGamers() {
      this.isDisplayInviteGamersModal = true;
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;

        GameService.getInvitedGamers(gameId, this.userData.userId, this.jwtToken, 'mainnet')
          .then((response: ResponseData) => {
            this.addedMainnetGamers = response.data;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    updateOnboardingChecklist(userId: string, token: string) {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 8, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    },

    getGameSubmission() {
      if (this.userData !== "" && this.jwtToken !== "" && this.$route.params.gameId !== undefined) {
        let gameId = this.$route.params.gameId;
        GameReleaseService.getGameSubmission(gameId, this.userData.userId, this.jwtToken, "1")
          .then((response: ResponseData) => {
            if (response.status === 200) {
              if (response.data.releaseDto !== null) {
                this.rejectedVersion = "Version " + response.data.releaseDto.version;
              } else {
                this.rejectedVersion = "No Version!";
              }
              this.rejectedText = response.data.reviewDto.text;
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    removeGamer(index: number) {
      this.invitedGamers.splice(index, 1);
    },
  },

  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    enableSubmitButton() {
      return this.previewCoverImage != '' && this.previewImage != '' && this.gallery.length > 0 && this.gameData.game.tags.length > 0 && this.gameData.game.languages.length > 0 && this.gameData.details.about != undefined;
    }
  },

  mounted() {
    this.getGameDetails();
  },
});
